var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coordinates || _vm.location)?_c('div',{staticClass:"resp-container"},[_c('iframe',{staticClass:"resp-iframe",attrs:{"id":"gmap_canvas","src":_vm.URL_MAP}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }